function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module widget/widgetresize
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import Resizer from './widgetresize/resizer';
import DomEmitterMixin from '@ckeditor/ckeditor5-utils/src/dom/emittermixin';
import global from '@ckeditor/ckeditor5-utils/src/dom/global';
import ObservableMixin from '@ckeditor/ckeditor5-utils/src/observablemixin';
import MouseObserver from '@ckeditor/ckeditor5-engine/src/view/observer/mouseobserver';
import mix from '@ckeditor/ckeditor5-utils/src/mix';
import { throttle } from 'lodash-es';
import '../theme/widgetresize.css';
/**
 * The widget resize feature plugin.
 *
 * Use the {@link module:widget/widgetresize~WidgetResize#attachTo} method to create a resizer for the specified widget.
 *
 * @extends module:core/plugin~Plugin
 * @mixes module:utils/observablemixin~ObservableMixin
 */

var WidgetResize = /*#__PURE__*/function (_Plugin) {
  _inherits(WidgetResize, _Plugin);

  var _super = _createSuper(WidgetResize);

  function WidgetResize() {
    _classCallCheck(this, WidgetResize);

    return _super.apply(this, arguments);
  }

  _createClass(WidgetResize, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var _this = this;

      /**
       * The currently visible resizer.
       *
       * @observable
       * @member {module:widget/widgetresize/resizer~Resizer|null} #visibleResizer
       */
      this.set('visibleResizer', null);
      /**
       * References an active resizer.
       *
       * Active resizer means a resizer which handle is actively used by the end user.
       *
       * @protected
       * @observable
       * @member {module:widget/widgetresize/resizer~Resizer|null} #_activeResizer
       */

      this.set('_activeResizer', null);
      /**
       * A map of resizers created using this plugin instance.
       *
       * @protected
       * @type {Map.<module:engine/view/containerelement~ContainerElement, module:widget/widgetresize/resizer~Resizer>}
       */

      this._resizers = new Map();
      var domDocument = global.window.document;
      this.editor.editing.view.addObserver(MouseObserver);
      this._observer = Object.create(DomEmitterMixin);
      this.listenTo(this.editor.editing.view.document, 'mousedown', this._mouseDownListener.bind(this), {
        priority: 'high'
      });

      this._observer.listenTo(domDocument, 'mousemove', this._mouseMoveListener.bind(this));

      this._observer.listenTo(domDocument, 'mouseup', this._mouseUpListener.bind(this));

      var redrawFocusedResizer = function redrawFocusedResizer() {
        if (_this.visibleResizer) {
          _this.visibleResizer.redraw();
        }
      };

      this._redrawFocusedResizerThrottled = throttle(redrawFocusedResizer, 200); // Redraws occurring upon a change of visible resizer must not be throttled, as it is crucial for the initial
      // render. Without it the resizer frame would be misaligned with resizing host for a fraction of second.

      this.on('change:visibleResizer', redrawFocusedResizer); // Redrawing on any change of the UI of the editor (including content changes).

      this.editor.ui.on('update', this._redrawFocusedResizerThrottled); // Resizers need to be redrawn upon window resize, because new window might shrink resize host.

      this._observer.listenTo(global.window, 'resize', this._redrawFocusedResizerThrottled);

      var viewSelection = this.editor.editing.view.document.selection;
      viewSelection.on('change', function () {
        var selectedElement = viewSelection.getSelectedElement();
        _this.visibleResizer = _this.getResizerByViewElement(selectedElement) || null;
      });
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this._observer.stopListening();

      var _iterator = _createForOfIteratorHelper(this._resizers.values()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var resizer = _step.value;
          resizer.destroy();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this._redrawFocusedResizerThrottled.cancel();
    }
    /**
     * @param {module:widget/widgetresize~ResizerOptions} [options] Resizer options.
     * @returns {module:widget/widgetresize/resizer~Resizer}
     */

  }, {
    key: "attachTo",
    value: function attachTo(options) {
      var resizer = new Resizer(options);
      var plugins = this.editor.plugins;
      resizer.attach();

      if (plugins.has('WidgetToolbarRepository')) {
        // Hiding widget toolbar to improve the performance
        // (https://github.com/ckeditor/ckeditor5-widget/pull/112#issuecomment-564528765).
        var widgetToolbarRepository = plugins.get('WidgetToolbarRepository');
        resizer.on('begin', function () {
          widgetToolbarRepository.forceDisabled('resize');
        }, {
          priority: 'lowest'
        });
        resizer.on('cancel', function () {
          widgetToolbarRepository.clearForceDisabled('resize');
        }, {
          priority: 'highest'
        });
        resizer.on('commit', function () {
          widgetToolbarRepository.clearForceDisabled('resize');
        }, {
          priority: 'highest'
        });
      }

      this._resizers.set(options.viewElement, resizer);

      var viewSelection = this.editor.editing.view.document.selection;
      var selectedElement = viewSelection.getSelectedElement(); // If the element the resizer is created for is currently focused, it should become visible.

      if (this.getResizerByViewElement(selectedElement) == resizer) {
        this.visibleResizer = resizer;
      }

      return resizer;
    }
    /**
     * Returns a resizer created for a given view element (widget element).
     *
     * @param {module:engine/view/containerelement~ContainerElement} viewElement View element associated with the resizer.
     * @returns {module:widget/widgetresize/resizer~Resizer|undefined}
     */

  }, {
    key: "getResizerByViewElement",
    value: function getResizerByViewElement(viewElement) {
      return this._resizers.get(viewElement);
    }
    /**
     * Returns a resizer that contains a given resize handle.
     *
     * @protected
     * @param {HTMLElement} domResizeHandle
     * @returns {module:widget/widgetresize/resizer~Resizer}
     */

  }, {
    key: "_getResizerByHandle",
    value: function _getResizerByHandle(domResizeHandle) {
      var _iterator2 = _createForOfIteratorHelper(this._resizers.values()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var resizer = _step2.value;

          if (resizer.containsHandle(domResizeHandle)) {
            return resizer;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
    /**
     * @protected
     * @param {module:utils/eventinfo~EventInfo} event
     * @param {Event} domEventData Native DOM event.
     */

  }, {
    key: "_mouseDownListener",
    value: function _mouseDownListener(event, domEventData) {
      var resizeHandle = domEventData.domTarget;

      if (!Resizer.isResizeHandle(resizeHandle)) {
        return;
      }

      this._activeResizer = this._getResizerByHandle(resizeHandle);

      if (this._activeResizer) {
        this._activeResizer.begin(resizeHandle); // Do not call other events when resizing. See: #6755.


        event.stop();
        domEventData.preventDefault();
      }
    }
    /**
     * @protected
     * @param {module:utils/eventinfo~EventInfo} event
     * @param {Event} domEventData Native DOM event.
     */

  }, {
    key: "_mouseMoveListener",
    value: function _mouseMoveListener(event, domEventData) {
      if (this._activeResizer) {
        this._activeResizer.updateSize(domEventData);
      }
    }
    /**
     * @protected
     */

  }, {
    key: "_mouseUpListener",
    value: function _mouseUpListener() {
      if (this._activeResizer) {
        this._activeResizer.commit();

        this._activeResizer = null;
      }
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'WidgetResize';
    }
  }]);

  return WidgetResize;
}(Plugin);

export { WidgetResize as default };
mix(WidgetResize, ObservableMixin);
/**
 * Interface describing a resizer. It allows to specify the resizing host, custom logic for calculating aspect ratio, etc.
 *
 * @interface ResizerOptions
 */

/**
 * Editor instance associated with the resizer.
 *
 * @member {module:core/editor/editor~Editor} module:widget/widgetresize~ResizerOptions#editor
 */

/**
 * @member {module:engine/model/element~Element} module:widget/widgetresize~ResizerOptions#modelElement
 */

/**
 * A view of an element to be resized. Typically it's the main widget's view instance.
 *
 * @member {module:engine/view/containerelement~ContainerElement} module:widget/widgetresize~ResizerOptions#viewElement
 */

/**
 * A callback to be executed once the resizing process is done.
 *
 * It receives a `Number` (`newValue`) as a parameter.
 *
 * For example, {@link module:image/imageresize~ImageResize} uses it to execute the resize image command
 * which puts the new value into the model.
 *
 * ```js
 * {
 *	editor,
 *	modelElement: data.item,
 *	viewElement: widget,
 *
 *	onCommit( newValue ) {
 *		editor.execute( 'resizeImage', { width: newValue } );
 *	}
 * };
 * ```
 *
 *
 * @member {Function} module:widget/widgetresize~ResizerOptions#onCommit
 */

/**
 * @member {Function} module:widget/widgetresize~ResizerOptions#getResizeHost
 */

/**
 * @member {Function} module:widget/widgetresize~ResizerOptions#isCentered
 */